export default {
  setRefreshComponentObj (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("setRefreshComponentObj", payload)
      resolve()
    })
  }
}
